const POLICY_MANAGEMENT_TYPE = {
  HIERARCHICAL: 'HIERARCHICAL',
  ASSET_GROUP: 'ASSET_GROUP',
  ADVANCED_HIERARCHY: 'ADVANCED_HIERARCHY'
};

const POLICY_TYPE = {
  SOFTWARE_MANAGEMENT: 'Software management'
};

const TABLE_ROW_COUNT = 10;

const STATUSENUM = {
  INSTALL_SCHEDULED: 'asset.software.install.scheduled',
  INSTALLED: 'asset.software.installed',
  UPGRADE_SCHEDULED: 'asset.software.upgrade.scheduled',
  UNINSTALL_SCHEDULED: 'asset.software.uninstall.scheduled',
  UNINSTALLED: 'asset.software.uninstalled',
  INSTALL_FAILED: 'asset.software.install.failed',
  UPGRADE_FAILED: 'asset.software.upgrade.failed',
  UNINSTALL_FAILED: 'asset.software.uninstall.failed'
};

const SOFTWARE_ACTIVITY_TYPE = {
  SOFTWARE_INSTALL: 'asset.activities.softwareInstallation.label',
  SOFTWARE_UNINSTALL: 'asset.activities.softwareunInstallation.label',
  SOFTWARE_UPGRADE: 'asset.activities.softwareupdate.label',
  INTEGRATION_AGENT_INSTALL_STATUS:
    'asset.activities.softwareInstallation.label'
};

const ACTIVITY_STATUS_KEY = {
  'In Progress': 'app.label.triggered',
  Failure: 'app.label.failure',
  Success: 'app.label.success'
};

const ACTIVITY_STATUS = {
  'In Progress': 'info',
  Failure: 'critical',
  Success: 'success'
};

const getStatusType = (value: string) => {
  if (value.includes('scheduled')) {
    return 'scheduled';
  }
  if (value.includes('failed')) {
    return 'failed';
  }
  if (value.includes('installed')) {
    return 'installed';
  }
  return '';
};

const getBadgeType = (status: any) => {
  const statusType = getStatusType(status.toLowerCase());
  switch (statusType) {
    case 'scheduled':
      return 'info';
    case 'failed':
      return 'critical';
    case 'installed':
      return 'success';
    default:
      return 'null';
  }
};

const WIHTOUT_WEBSOCKET_AGENT_VERSION = 202207120606;
const TOP_CPU_MEMORY_AGENT_VERSION = 202209191547;
const TROUBLE_SHOOT_AGENT_VERSION = '202210030910';
const WAKEONLAN_REBOOT_AGENT_VERSION = '202211151251';

const ASSET_ACTIVITY_TYPE = {
  CLIENT_UPDATE: 'CLIENT_UPDATE',
  SITE_UPDATE: 'SITE_UPDATE',
  REQUESTER_UPDATE: 'REQUESTER_UPDATE',
  ASSET_REGISTERED: 'ASSET_REGISTERED',
  ASSET_ADDED_TO_MONITORING: 'ASSET_ADDED_TO_MONITORING',
  ASSET_CREATED: 'ASSET_CREATED',
  MDM_COMMANDS: 'MDM_COMMANDS',
  AUTO_ASSIGN_REQUESTER: 'AUTO_ASSIGN_REQUESTER',
  ASSET_MERGE: 'ASSET_MERGE'
};

const CUSTOM_FIELDS = {
  RICH_TEXT: 'RICH_TEXT',
  secureText: 'SECURE_TEXT',
  totp: 'TOTP'
};
const ASSET_DEFAULT_EDITABLE_FIELDS = ['warrantyExpiryDate', 'purchasedDate'];

// Remove these hard-coded values from the backend configuration
const ASSETS_LIST = {
  WINDOWS: '1',
  MAC: '3',
  PRINTER: '4',
  LINUX: '2',
  ROUTER: '5',
  SWITCH: '6',
  FIREWALL: '7',
  UPS: '8',
  LoadBalancer: '9',
  PowerDistributionUnit: '10',
  Storage: '11',
  WANAccelerator: '12',
  WirelessAccessPoint: '13',
  WirelessLANController: '14',
  VOIP: '15',
  IPCamera: '16',
  NAS: '17',
  ServerHardwareController: '18',
  ANDROID: '41',
  APPLE_IOS: '42',
  APPLE_IPAD_OS: '43'
};

const ASSETS_LIST_NUM = {
  '1': 'Windows',
  '3': 'Mac',
  '4': 'Printer',
  '2': 'LinuxIcon',
  '5': 'Router',
  '6': 'Switch',
  '7': 'Firewall',
  '8': 'UPS',
  '9': 'LoadBalancer',
  '10': 'PowerDevice',
  '11': 'Storage',
  '12': 'Wan',
  '13': 'WireLessAccessPoint',
  '14': 'WirelessLanController',
  '15': 'Voip',
  '16': 'IpCamera',
  '17': 'NAS',
  '18': 'ServerHardwareController',
  '41': 'Android',
  '42': 'AppleIOS',
  '43': 'AppleIPadOS'
};

const TROUBLESHOOT_SOLUTION_LINK =
  'https://support.superops.ai/en/articles/6700715-troubleshooting-issues-with-splashtop';

const SPLASHTOP_VIEWER_DOWNLOAD_WINDOWS_URL =
  'https://my.splashtop.com/rmm/win';
const ISL_DOWNLOAD_WINDOWS_URL =
  'https://www.islonline.net/download/ISLLight?custom=superopsrd&platform=win32';
const ISL_DOWNLOAD_MAC_URL =
  'https://www.islonline.net/download/ISLLight?custom=superopsrd&platform=mac';
const ISL_DOWNLOAD_LINUX_URL =
  'https://www.islonline.net/download/ISLLight?custom=superopsrd&platform=linux64';

const SPLASHTOP_VIEWER_DOWNLOAD_MAC_URL = 'https://my.splashtop.com/rmm/mac';

const SPLASHTOP_NAME = 'SUPEROPS_SPLASH_TOP';

const ALL_ASSET_TYPES = {
  ALL_ASSETS: 'ALL_ASSET',
  ALL_MONITORED_ASSET: 'ALL_MONITORED_ASSET',
  WORKSTATION_ASSET: 'WORKSTATION_ASSET',
  PRINTER_ASSET: 'PRINTER_ASSET',
  SWITCH_ASSET: 'SWITCH_ASSET',
  ROUTER_ASSET: 'ROUTER_ASSET',
  FIREWALL_ASSET: 'FIREWALL_ASSET',
  UPS: 'UPS_ASSET',
  LOAD_BALANCER: 'LOAD_BALANCER_ASSET',
  POWER_DISTRIBUTION_UNIT: 'POWER_DISTRIBUTION_UNIT_ASSET',
  STORAGE: 'STORAGE_ASSET',
  WAN_ACCELERATOR: 'WAN_ACCELERATOR_ASSET',
  WIRELESS_ACCESS_POINT: 'WIRELESS_ACCESS_POINT_ASSET',
  WIRELESS_LAN_CONTROLLER: 'WIRELESS_LAN_CONTROLLER_ASSET',
  VOIP: 'VOIP_ASSET',
  IP_CAMERA: 'IP_CAMERA_ASSET',
  ALL_NON_MONITORED_ASSET: 'ALL_NON_MONITORED_ASSET',
  NAS: 'NAS_ASSET',
  SERVER_HARDWARE_CONTROLLER_ASSET: 'SERVER_HARDWARE_CONTROLLER_ASSET',
  ALL_UNLICENSED_ASSET: 'ALL_UNLICENSED_ASSET',
  WAN_ROUTER_ASSET: 'WAN_ROUTER_ASSET',
  NETWORK_VIDEO_RECORDER_ASSET: 'NETWORK_VIDEO_RECORDER_ASSET',
  ETHERNET_IP_BRIDGE_ASSET: 'ETHERNET/IP_BRIDGE_ASSET',
  TEMPERATURE_SENSOR_ASSET: 'TEMPERATURE_SENSOR_ASSET',
  DOMAIN_CONTROLLER_ASSET: 'DOMAIN_CONTROLLER_ASSET',
  VMWARE_ESXI_ASSET: 'VMWARE_ESXI_ASSET',
  ENVIRONMENTAL_MONITORING_DEVICE_ASSET:
    'ENVIRONMENTAL_MONITORING_DEVICE_ASSET',
  SERIAL_DEVICE_SERVER_ASSET: 'SERIAL_DEVICE_SERVER_ASSET',
  PRESENTATION_GATEWAY_ASSET: 'PRESENTATION_GATEWAY_ASSET',
  VOIP_GATEWAY_ASSET: 'VOIP_GATEWAY_ASSET',
  USB_HUB_ASSET: 'USB_HUB_ASSET',
  X_TERMINAL_ASSET: 'X_TERMINAL_ASSET',
  ETHERNET_GATEWAY_ASSET: 'ETHERNET_GATEWAY_ASSET',
  PBX_ASSET: 'PBX_ASSET',
  ETHERNET_CARD_ASSET: 'ETHERNET_CARD_ASSET',
  AUDIO_CODEC_ASSET: 'AUDIO_CODEC_ASSET',
  RF_TRANSMITTER_ASSET: 'RF_TRANSMITTER_ASSET',
  TAPE_LIBRARY_ASSET: 'TAPE_LIBRARY_ASSET',
  KVM_SWITCH_ASSET: 'KVM_SWITCH_ASSET',
  ZERO_CLIENT_ASSET: 'ZERO_CLIENT_ASSET',
  BARCODE_PRINTER_ASSET: 'BARCODE_PRINTER_ASSET',
  SAN_ASSET: 'SAN_ASSET',
  ANDROID_ASSET: 'ANDROID_ASSET',
  APPLE_IOS_ASSET: 'APPLE_IOS_ASSET',
  APPLE_IPADOS_ASSET: 'APPLE_IPADOS_ASSET'
};

const getAssetsEntityType = (viewSubType: string) => {
  switch (viewSubType) {
    case ALL_ASSET_TYPES.ALL_NON_MONITORED_ASSET:
    case ALL_ASSET_TYPES.ALL_ASSETS:
      return 'Asset';
    case ALL_ASSET_TYPES.ALL_MONITORED_ASSET:
      return 'IPAsset';
    case ALL_ASSET_TYPES.PRINTER_ASSET:
      return 'Printer';
    case ALL_ASSET_TYPES.SWITCH_ASSET:
      return 'Switch';
    case ALL_ASSET_TYPES.ROUTER_ASSET:
      return 'Router';
    case ALL_ASSET_TYPES.FIREWALL_ASSET:
      return 'Firewall';
    case ALL_ASSET_TYPES.IP_CAMERA:
      return 'IPCamera';
    case ALL_ASSET_TYPES.LOAD_BALANCER:
      return 'LoadBalancer';
    case ALL_ASSET_TYPES.POWER_DISTRIBUTION_UNIT:
      return 'PowerDistributionUnit';
    case ALL_ASSET_TYPES.STORAGE:
      return 'Storage';
    case ALL_ASSET_TYPES.UPS:
      return 'UPS';
    case ALL_ASSET_TYPES.VOIP:
      return 'VOIP';
    case ALL_ASSET_TYPES.WAN_ACCELERATOR:
      return 'WANAccelerator';
    case ALL_ASSET_TYPES.WIRELESS_ACCESS_POINT:
      return 'WirelessAccessPoint';
    case ALL_ASSET_TYPES.WIRELESS_LAN_CONTROLLER:
      return 'WirelessLANController';
    case ALL_ASSET_TYPES.NAS:
      return 'NAS';
    case ALL_ASSET_TYPES.SERVER_HARDWARE_CONTROLLER_ASSET:
      return 'ServerHardwareController';
    case ALL_ASSET_TYPES.WAN_ROUTER_ASSET:
      return 'WANRouter';
    case ALL_ASSET_TYPES.NETWORK_VIDEO_RECORDER_ASSET:
      return 'NetworkVideoRecorder';
    case ALL_ASSET_TYPES.ETHERNET_IP_BRIDGE_ASSET:
      return 'EthernetIPBridge';
    case ALL_ASSET_TYPES.TEMPERATURE_SENSOR_ASSET:
      return 'TemperatureSensor';
    case ALL_ASSET_TYPES.DOMAIN_CONTROLLER_ASSET:
      return 'DomainController';
    case ALL_ASSET_TYPES.VMWARE_ESXI_ASSET:
      return 'VmwareESXI';
    case ALL_ASSET_TYPES.ENVIRONMENTAL_MONITORING_DEVICE_ASSET:
      return 'EnvironmentalMonitoringDevice';
    case ALL_ASSET_TYPES.SERIAL_DEVICE_SERVER_ASSET:
      return 'SerialDeviceServer';
    case ALL_ASSET_TYPES.PRESENTATION_GATEWAY_ASSET:
      return 'PresentationGateway';
    case ALL_ASSET_TYPES.VOIP_GATEWAY_ASSET:
      return 'VoIPGateway';
    case ALL_ASSET_TYPES.USB_HUB_ASSET:
      return 'USBHub';
    case ALL_ASSET_TYPES.X_TERMINAL_ASSET:
      return 'XTerminal';
    case ALL_ASSET_TYPES.ETHERNET_GATEWAY_ASSET:
      return 'EthernetGateway';
    case ALL_ASSET_TYPES.PBX_ASSET:
      return 'PBX';
    case ALL_ASSET_TYPES.ETHERNET_CARD_ASSET:
      return 'EthernetCard';
    case ALL_ASSET_TYPES.AUDIO_CODEC_ASSET:
      return 'AudioCodec';
    case ALL_ASSET_TYPES.RF_TRANSMITTER_ASSET:
      return 'RfTransmitter';
    case ALL_ASSET_TYPES.TAPE_LIBRARY_ASSET:
      return 'TapeLibrary';
    case ALL_ASSET_TYPES.KVM_SWITCH_ASSET:
      return 'KVMSwitch';
    case ALL_ASSET_TYPES.ZERO_CLIENT_ASSET:
      return 'ZeroClient';
    case ALL_ASSET_TYPES.BARCODE_PRINTER_ASSET:
      return 'BarcodePrinter';
    case ALL_ASSET_TYPES.SAN_ASSET:
      return 'SAN';
    case ALL_ASSET_TYPES.ANDROID_ASSET:
      return 'Android';
    case ALL_ASSET_TYPES.APPLE_IOS_ASSET:
      return 'AppleIOS';
    case ALL_ASSET_TYPES.APPLE_IPADOS_ASSET:
      return 'AppleIPadOS';
    default:
      return 'WorkStation';
  }
};

const ASSET_TYPES = [
  {
    label: 'All monitored asset',
    name: ALL_ASSET_TYPES.ALL_MONITORED_ASSET,
    value: 'ALL_MONITORED_ASSET',
    entity: 'asset'
  },
  {
    label: 'Android asset',
    name: ALL_ASSET_TYPES.ANDROID_ASSET,
    value: 'ANDROID_ASSET',
    entity: 'Android'
  },
  {
    label: 'Apple iOS asset',
    name: ALL_ASSET_TYPES.APPLE_IOS_ASSET,
    value: 'APPLE_IOS_ASSET',
    entity: 'AppleIOS'
  },
  {
    label: 'Apple iPad OS asset',
    name: ALL_ASSET_TYPES.APPLE_IPADOS_ASSET,
    value: 'APPLE_IPADOS_ASSET',
    entity: 'AppleIPadOS'
  },
  {
    label: 'All asset',
    name: ALL_ASSET_TYPES.ALL_ASSETS,
    value: 'ALL_ASSET',
    entity: 'Asset'
  },
  {
    label: 'All non monitored asset',
    name: ALL_ASSET_TYPES.ALL_NON_MONITORED_ASSET,
    value: 'ALL_NON_MONITORED_ASSET',
    entity: 'Asset'
  },
  {
    label: 'Workstation asset',
    name: ALL_ASSET_TYPES.WORKSTATION_ASSET,
    value: 'WORKSTATION_ASSET',
    entity: 'asset'
  },
  {
    label: 'Printer asset',
    name: ALL_ASSET_TYPES.PRINTER_ASSET,
    value: 'PRINTER_ASSET',
    entity: 'Printer'
  },
  {
    label: 'Router asset',
    name: ALL_ASSET_TYPES.ROUTER_ASSET,
    value: ALL_ASSET_TYPES.ROUTER_ASSET,
    entity: 'Router'
  },
  {
    label: 'Switch asset',
    name: ALL_ASSET_TYPES.SWITCH_ASSET,
    value: ALL_ASSET_TYPES.SWITCH_ASSET,
    entity: 'Switch'
  },
  {
    label: 'Firewall asset',
    name: ALL_ASSET_TYPES.FIREWALL_ASSET,
    value: ALL_ASSET_TYPES.FIREWALL_ASSET,
    entity: 'Firewall'
  },
  {
    label: 'Ip Camera',
    name: ALL_ASSET_TYPES.IP_CAMERA,
    value: ALL_ASSET_TYPES.IP_CAMERA,
    entity: 'IPCamera'
  },
  {
    label: 'Load balancer',
    name: ALL_ASSET_TYPES.LOAD_BALANCER,
    value: ALL_ASSET_TYPES.LOAD_BALANCER,
    entity: 'LoadBalancer'
  },
  {
    label: 'Power unit',
    name: ALL_ASSET_TYPES.POWER_DISTRIBUTION_UNIT,
    value: ALL_ASSET_TYPES.POWER_DISTRIBUTION_UNIT,
    entity: 'PowerDistributionUnit'
  },
  {
    label: 'Storage',
    name: ALL_ASSET_TYPES.STORAGE,
    value: ALL_ASSET_TYPES.STORAGE,
    entity: 'Storage'
  },
  {
    label: 'UPS',
    name: ALL_ASSET_TYPES.UPS,
    value: ALL_ASSET_TYPES.UPS,
    entity: 'UPS'
  },
  {
    label: 'VOIP',
    name: ALL_ASSET_TYPES.VOIP,
    value: ALL_ASSET_TYPES.VOIP,
    entity: 'VOIP'
  },
  {
    label: 'Wan Accelerator',
    name: ALL_ASSET_TYPES.WAN_ACCELERATOR,
    value: ALL_ASSET_TYPES.WAN_ACCELERATOR,
    entity: 'WANAccelerator'
  },
  {
    label: 'Wan Access Point',
    name: ALL_ASSET_TYPES.WIRELESS_ACCESS_POINT,
    value: ALL_ASSET_TYPES.WIRELESS_ACCESS_POINT,
    entity: 'WirelessAccessPoint'
  },
  {
    label: 'Wireless lan controller',
    name: ALL_ASSET_TYPES.WIRELESS_LAN_CONTROLLER,
    value: ALL_ASSET_TYPES.WIRELESS_LAN_CONTROLLER,
    entity: 'WirelessLANController'
  },
  {
    label: 'NAS',
    name: ALL_ASSET_TYPES.NAS,
    value: ALL_ASSET_TYPES.NAS,
    entity: 'NAS'
  },
  {
    label: 'Server Hardware Controller',
    name: ALL_ASSET_TYPES.SERVER_HARDWARE_CONTROLLER_ASSET,
    value: ALL_ASSET_TYPES.SERVER_HARDWARE_CONTROLLER_ASSET,
    entity: 'ServerHardwareController'
  }
];

const getViewType = (classId: string) => {
  switch (classId) {
    case ASSETS_LIST.FIREWALL:
      return ALL_ASSET_TYPES.FIREWALL_ASSET;
    case ASSETS_LIST.SWITCH:
      return ALL_ASSET_TYPES.SWITCH_ASSET;
    case ASSETS_LIST.ROUTER:
      return ALL_ASSET_TYPES.ROUTER_ASSET;
    case ASSETS_LIST.PRINTER:
      return ALL_ASSET_TYPES.PRINTER_ASSET;
    case ASSETS_LIST.IPCamera:
      return ALL_ASSET_TYPES.IP_CAMERA;
    case ASSETS_LIST.LoadBalancer:
      return ALL_ASSET_TYPES.LOAD_BALANCER;
    case ASSETS_LIST.PowerDistributionUnit:
      return ALL_ASSET_TYPES.POWER_DISTRIBUTION_UNIT;
    case ASSETS_LIST.Storage:
      return ALL_ASSET_TYPES.STORAGE;
    case ASSETS_LIST.UPS:
      return ALL_ASSET_TYPES.UPS;
    case ASSETS_LIST.VOIP:
      return ALL_ASSET_TYPES.VOIP;
    case ASSETS_LIST.WANAccelerator:
      return ALL_ASSET_TYPES.WAN_ACCELERATOR;
    case ASSETS_LIST.WirelessAccessPoint:
      return ALL_ASSET_TYPES.WIRELESS_ACCESS_POINT;
    case ASSETS_LIST.WirelessLANController:
      return ALL_ASSET_TYPES.WIRELESS_LAN_CONTROLLER;
    case ASSETS_LIST.NAS:
      return ALL_ASSET_TYPES.NAS;
    case ASSETS_LIST.ServerHardwareController:
      return ALL_ASSET_TYPES.SERVER_HARDWARE_CONTROLLER_ASSET;
    default:
      return null;
  }
};

const PATCH_COLOR_MAP = {
  Critical: 'critical',
  Important: 'warning',
  High: 'warning',
  Medium: 'attention',
  Low: 'success',
  Optional: 'info',
  Others: '',
  Recommended: 'critical'
};

const NON_MONITOR_ASSET_CLASSES = [
  {
    content: 'Keyboard',
    iconName: 'Keyboard'
  },
  {
    content: 'Smart TV',
    iconName: 'SmartTV'
  },
  {
    content: 'Mouse',
    iconName: 'Mouse'
  },
  {
    content: 'Monitor',
    iconName: 'System'
  },
  {
    content: 'Smartphone',
    iconName: 'Phone'
  },
  {
    content: 'Webcam',
    iconName: 'IpCamera'
  }
];

const SUPPORTED_MODULE_TYPES = {
  ENDPOINT_MANAGEMENT: 'ENDPOINT_MANAGEMENT',
  NETWORK_MONITORING: 'NETWORK_MONITORING',
  MOBILE_DEVICE_MANAGEMENT: 'MOBILE_DEVICE_MANAGEMENT',
  ENDPOINT: 'ENDPOINT',
  NM_ASSET: 'NM_ASSET',
  ASSET: 'ASSET',
  OTHER_ASSET: 'OTHER_ASSET'
};

const AV_SERVER_AGENT_VERSION = '202406071557';

const MODULE_TYPES = {
  ASSET: 'ASSET',
  endpoint: 'ENDPOINT',
  asset: 'ASSET',
  nm_asset: 'NM_ASSET',
  MDM: 'MDM'
};

const MIGRATION_STATUS_TYPES = {
  completed: 'MIGRATION_COMPLETED',
  inProgress: 'MIGRATION_IN_PROGRESS',
  notStarted: 'MIGRATION_NOT_STARTED'
};

const POLICY_RMM_TRANSITION = {
  completed: 'COMPLETED',
  started: 'START',
  notStarted: 'NOT_STARTED'
};

const LINK_STATUS = {
  WIRED: 'wired',
  WIRELESS: 'wireless',
  INFERRED_WIRED: 'inferredWired',
  INFERRED_WIRELESS: 'inferredWireless',
  CRITICAL_WIRED: 'criticalWired',
  CRITICAL_WIRELESS: 'criticalWireless'
};

const LINK_STATUS_TEXT = {
  wired: 'msp.topology.wired',
  wireless: 'msp.topology.wireless',
  inferredWired: 'msp.topology.inferredWired',
  inferredWireless: 'msp.topology.inferredWireless',
  criticalWired: 'msp.topology.criticalWired',
  criticalWireless: 'msp.topology.criticalwireless'
};

const DEVICE_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  UNKNOWN: 'UNKNOWN'
};

const DEVICE_MONITORING_STATUS = {
  MANAGED: 'SUPPORTED',
  UN_MANAGED: 'UN_MANAGED',
  NOT_SUPPORTED: 'NOT_SUPPORTED'
};

const TAB_CONSTANT_ID = {
  TICKETS: 'TICKETS',
  ALERTS: 'ALERTS'
};

const CUSTOM_SOFTWARE_STATUS = {
  INITIALISED: 'INITIALISED',
  VIRUS_SCAN_FAILED: 'VIRUS_SCAN_FAILED',
  SUCCESS: 'SUCCESS',
  FILE_UPLOAD_FAILED: 'FILE_UPLOAD_FAILED',
  FILE_UPLOAD_PROGRESS: 'FILE_UPLOAD_PROGRESS'
};

const SOFTWARE_INSTALLATION_ERROR_BASE_URL =
  'https://support.superops.com/en/articles/11756376-errors-you-may-encounter-while-deploying-third-party-software-through-superops';

const ERROR_CODE_HASH_MAP: Record<string, string> = {
  '1638': '#h_349cd89766',
  '0x80070057': '#h_92e4455381',
  '3762504530': '#h_0b13183806',
  '17006': '#h_c09c5571c3',
  '1618': '#h_467c592902',
  '1': '#h_6898173841',
  '17002': '#h_75d0ed803b',
  '1603': '#h_ec6749d866',
  '255': '#h_047ad97a7a',
  '2250': '#h_acae174c3a',
  '4294967295': '#h_74ecb6ff6d',
  '0x80070002': '#h_ea904bd89b',
  '150110': '#h_98009e3457',
  '7': '#h_e81f5b7ec8',
  '17003': '#h_65b192e125',
  '2': '#h_79d0e5a197',
  '112': '#h_bccc49bc10',
  '0x80190003': '#h_49dd59079a',
  '1001': '#h_f036b39e22',
  '1648': '#h_f38f645898',
  '0x80072efe': '#h_4f607c90d6',
  '118': '#h_d4ba073b34',
  '0x800706d9': '#h_5bcd9ea693'
};

function getSoftwareInstallationErrorArticleUrl(errorCode: string): string {
  const hash = ERROR_CODE_HASH_MAP[errorCode] ?? '';
  return `${SOFTWARE_INSTALLATION_ERROR_BASE_URL}${hash}`;
}

const BULK_SELECTION_TYPE = {
  SELECTED: 'SELECTED',
  ALL: 'ALL',
  UNSELECTED: 'UNSELECTED'
};

const STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

const OS_UPDATE_STATUS = {
  NONE: 'none',
  WAITING: 'waiting',
  DOWNLOADING: 'downloading',
  PREPARED: 'prepared',
  INSTALLING: 'installing',
  FAILED: 'failed'
};

const OS_UPDATE_STATUS_ICONS = {
  [OS_UPDATE_STATUS.NONE]: 'RestrictIcon',
  [OS_UPDATE_STATUS.WAITING]: 'HourGlassWirePaused',
  [OS_UPDATE_STATUS.DOWNLOADING]: 'Download',
  [OS_UPDATE_STATUS.PREPARED]: 'Download',
  [OS_UPDATE_STATUS.INSTALLING]: 'DiscoveredAssets',
  [OS_UPDATE_STATUS.FAILED]: 'WarningIcon'
};

const CVE_BASE_URL = (cve: string | number) =>
  `https://cve.mitre.org/cgi-bin/cvename.cgi?name=${cve}`;

const BATTERY_HEALTH = {
  NORMAL: 'normal',
  NON_GENUINE: 'non-genuine',
  SERVICE_RECOMMENDED: 'service-recommended',
  UNKNOWN: 'unknown',
  UNSUPPORTED: 'unsupported'
};

export {
  POLICY_MANAGEMENT_TYPE,
  POLICY_TYPE,
  TABLE_ROW_COUNT,
  STATUSENUM,
  ACTIVITY_STATUS,
  getBadgeType,
  SOFTWARE_ACTIVITY_TYPE,
  ACTIVITY_STATUS_KEY,
  WIHTOUT_WEBSOCKET_AGENT_VERSION,
  TOP_CPU_MEMORY_AGENT_VERSION,
  WAKEONLAN_REBOOT_AGENT_VERSION,
  ASSET_ACTIVITY_TYPE,
  CUSTOM_FIELDS,
  ASSETS_LIST,
  TROUBLE_SHOOT_AGENT_VERSION,
  TROUBLESHOOT_SOLUTION_LINK,
  SPLASHTOP_VIEWER_DOWNLOAD_WINDOWS_URL,
  SPLASHTOP_VIEWER_DOWNLOAD_MAC_URL,
  SPLASHTOP_NAME,
  ASSET_DEFAULT_EDITABLE_FIELDS,
  ASSET_TYPES,
  ALL_ASSET_TYPES,
  getAssetsEntityType,
  getViewType,
  ASSETS_LIST_NUM,
  PATCH_COLOR_MAP,
  NON_MONITOR_ASSET_CLASSES,
  AV_SERVER_AGENT_VERSION,
  SUPPORTED_MODULE_TYPES,
  MODULE_TYPES,
  MIGRATION_STATUS_TYPES,
  POLICY_RMM_TRANSITION,
  LINK_STATUS,
  DEVICE_STATUS,
  DEVICE_MONITORING_STATUS,
  LINK_STATUS_TEXT,
  TAB_CONSTANT_ID,
  ISL_DOWNLOAD_WINDOWS_URL,
  ISL_DOWNLOAD_MAC_URL,
  ISL_DOWNLOAD_LINUX_URL,
  CUSTOM_SOFTWARE_STATUS,
  SOFTWARE_INSTALLATION_ERROR_BASE_URL,
  getSoftwareInstallationErrorArticleUrl,
  BULK_SELECTION_TYPE,
  STATUS,
  OS_UPDATE_STATUS,
  OS_UPDATE_STATUS_ICONS,
  CVE_BASE_URL,
  BATTERY_HEALTH
};
